<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Details</h1>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                                <v-select
                                    :items="stores"
                                    item-text="Name"
                                    item-value="ID"
                                    v-model="order.StoreID"
                                    label="Store"
                                    hint="Store"
                                    readonly
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                                <v-select
                                    :items="departmentsInSelectedStore"
                                    item-text="Name"
                                    item-value="ID"
                                    v-model="order.DepartmentID"
                                    label="Department"
                                    hint="Department"
                                    no-data-text="No departments for this store"
                                    readonly
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                                <v-text-field
                                    slot="activator"
                                    v-model="order.Date"
                                    label="Order Date"
                                    prepend-icon="event"
                                    hint="Order Date"
                                    readonly
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-card>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Items</h1>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                            <v-data-table
                                :headers="headers"
                                :items="orderSuppliers"
                                hide-actions
                                must-sort
                                :pagination.sync="pagination"
                            >
                                <template slot="items" slot-scope="props">
                                    <tr :data-id="props.item.Supplier.ID">
                                        <td>{{ props.item.Supplier.Name }}</td>
                                        <td>{{ props.item.Supplier.Email }}</td>
                                        <td>{{ props.item.OrderProducts.length }}</td>
                                        <td>{{ props.item.TotalQuantity }}</td>
                                        <td v-if="displayStock">{{ props.item.TotalStock}}</td>
                                    </tr>
                                </template>
                                <template slot="no-data">
                                    <v-alert outline :value="true" type="info">
                                        Item list is empty.
                                    </v-alert>
                                </template>
                            </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-card>
                <v-layout wrap class="dialog-action-buttons">
                    <v-flex xs12 md6>
                        <v-btn block color="error" @click="goBack">Modify Order</v-btn>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-btn block color="success" :loading="sending" @click="confirmOrder">Send To Suppliers</v-btn>
                    </v-flex>
                    <v-flex xs12>
                        <error-alert :content="sendError" :display="sendError"></error-alert>
                    </v-flex>
                </v-layout>   
            </v-card>                         
        </v-flex>
    </v-layout>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import ErrorAlert from "../common/ErrorAlert";
import auth from '@/services/auth';
import util from '@/services/util';

export default {
    components: {
        ErrorAlert
    },
    props: [
        'loading',
        'sending',
        'sendError',
        'showStockEntry'
    ],
    data() {
        return {
            pagination: {
                sortBy: "Supplier.Name",
                rowsPerPage: -1
            },
            displayStock:false,
            headers: [
                {
                    text: "Supplier",
                    value: "Supplier.Name",
                    width: "20%"
                },
                {
                    text: "Email",
                    value: "Supplier.Email",
                    width: "20%"
                },
                {
                    text: "Products",
                    value: "OrderProducts.length",
                    width: "20%"
                },
                {
                    text: "Total Quantity",
                    value: "TotalQuantity",
                    width: "20%"
                }
            ]
        };
    },
    computed: {
        order(){
            return this.$store.state.placeOrderStore.order;
        },
        orderProducts(){
            return this.$store.state.placeOrderStore.orderProducts;
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active && auth.hasAccessToStore(s.ID)).sort(util.sortByName);
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active && auth.hasAccessToDepartment(d.ID)).sort(util.sortByName);
        },
        departmentsInSelectedStore(){
            let selectedStoreID = this.order.StoreID;

            return this.departments.filter(d => {
                if(!selectedStoreID){
                    return false;
                }

                let selectedStore = this.stores.find(s => s.ID == selectedStoreID);
                if(!selectedStore.DepartmentIDs){
                    return false;
                }
                
                let selectedStoreContainsDepartment = selectedStore.DepartmentIDs.split(",").some(dID => dID == d.ID);
                if(!selectedStoreContainsDepartment){
                    return false;
                }

                return true;
            });
        },
        selectedDepartment(){
            return this.departmentsInSelectedStore.find(d => d.ID == this.order.DepartmentID);
        },
        products() {
            return this.$store.state.productStore.products.filter(p => p.Active).sort(util.sortByName);
        },
        categories() {
            return this.$store.state.categoryStore.categories.filter(c => c.Active).sort(util.sortByName);
        },
        orderSuppliers(){
            let orderSuppliers = [];

            for(let i = 0; i < this.orderProducts.length; i++){
                let existingSupplier = orderSuppliers.find(s => s.Supplier.ID == this.orderProducts[i].Supplier.ID);
                if(!existingSupplier){
                    existingSupplier = {
                        Supplier: this.orderProducts[i].Supplier,
                        OrderProducts: [],
                        get TotalStock(){
                            let total = 0;

                            for(let i = 0; i < this.OrderProducts.length; i++){
                                if(isNaN(this.OrderProducts[i].Stock)){
                                    continue;
                                }
                                
                                if(this.OrderProducts[i].Stock!=null && this.OrderProducts[i].Stock>0){
                                    let stock = parseInt(this.OrderProducts[i].Stock);
                                    total += stock;
                                }
                            }

                            if(total > 0){
                                return total;
                            }else{
                                return;
                            }
                        },
                        get TotalQuantity(){
                            let total = 0;

                            for(let i = 0; i < this.OrderProducts.length; i++){
                                if(isNaN(this.OrderProducts[i].Quantity)){
                                    continue;
                                }

                                let quantity = parseInt(this.OrderProducts[i].Quantity);
                                total += quantity;
                            }

                            return total;
                        }
                    };

                    orderSuppliers.push(existingSupplier);
                }

                existingSupplier.OrderProducts.push(this.orderProducts[i]);
            }

            return orderSuppliers;
        }
    },
    methods: {
        goBack(){
            this.$emit("onCancel");
        },
        confirmOrder() {
            this.$emit("onConfirm");
        },
        checkDepartment(){
            if(this.showStockEntry==true || this.selectedDepartment.Name=="Organics"){
                this.displayStock = true;
                this.headers.push({
                    text: "Total Stock",
                    value: "TotalStock",
                    width: "20%"
                })
             }
        }
    },
   created(){
        this.checkDepartment();
    }
};
</script>

<style>

</style>
